import type { TranslationExclusionValue } from '../../types';

const WIDGET_CLASS = 'eapps-website-translator';

export function checkExcludedNode(
  node: Node,
  translationExclusions?: TranslationExclusionValue[]
): boolean {
  let parent = node.parentNode as HTMLElement;

  while (parent) {
    if (parent.classList) {
      if (parent.classList.value.includes(WIDGET_CLASS)) {
        return true;
      }

      if (translationExclusions && translationExclusions.length > 0) {
        const parentClassListValue = parent.classList.value.split(' ');

        const isExisted = translationExclusions.some(({ value }) => {
          if (!value.trim()) {
            return false;
          }

          const isClassName = value.startsWith('.');

          if (isClassName) {
            const formatValue = value.replace('.', '');

            return parentClassListValue.includes(formatValue);
          }

          return;
        });

        if (isExisted) {
          return true;
        }
      }
    }

    parent = parent.parentNode as HTMLElement;
  }

  return false;
}
